var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrayaCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1186_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8203 0C20.9119 0 18.459 2.45293 18.459 5.36132C18.459 8.2697 20.9119 10.7226 23.8203 10.7226C26.7287 10.7226 29.0937 8.2697 29.0937 5.36132C29.0937 2.45293 26.7287 0 23.8203 0Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6731 10.7227C28.2242 12.3292 26.149 13.3594 23.8203 13.3594C21.4916 13.3594 19.3285 12.3292 17.8796 10.7227C16.6147 12.1253 15.8223 13.9628 15.8223 15.9961V17.3144C15.8223 18.0431 16.4119 18.6328 17.1406 18.6328H30.4121C31.1408 18.6328 31.7304 18.0431 31.7304 17.3144V15.9961C31.7304 13.9628 30.938 12.1253 29.6731 10.7227Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7392 40.4652L6.02073 26.9955C5.37201 25.6948 3.79315 25.1644 2.49088 25.8096L0.734922 26.6794C0.0811059 27.0037 -0.184938 27.7983 0.141399 28.451L8.05153 44.2713C8.37681 44.9237 9.16809 45.1833 9.81663 44.8635L11.55 44.0047C12.8574 43.3571 13.3902 41.7708 12.7392 40.4652Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9221 21.7704C42.8409 20.9794 41.338 21.1376 40.4416 22.1132L33.2346 30.9726C32.7336 31.4999 31.7844 31.8163 31.2834 31.8163H25.1398C24.4014 31.8163 23.8214 31.2363 23.8214 30.498C23.8214 29.7596 24.4014 29.1796 25.1398 29.1796C26.9055 29.1796 28.8604 29.1796 30.4132 29.1796C31.8634 29.1796 33.0499 27.9931 33.0499 26.5429C33.0499 25.0927 31.8634 23.9062 30.4132 23.9062C24.2217 23.9062 30.1276 23.9062 23.505 23.9062C22.848 23.9062 22.5203 23.4895 22.0021 23.036C19.9622 21.2004 16.9089 20.316 13.8178 21.0325C12.1015 21.4303 10.9441 22.1237 9.7702 23.0534L9.73109 23.0216L7.82422 24.6998L15.3181 39.7265H17.5372H30.4132C32.8917 39.7265 35.2649 38.5399 36.7414 36.5624L44.4757 25.4882C45.3458 24.328 45.1085 22.6406 43.9221 21.7704Z",
    fill: "#A3937A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1186_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrayaCustomer);
export default __webpack_public_path__ + "static/media/praya-customer.847408f69b881a3a91f0dbd0add3c981.svg";
export { ForwardRef as ReactComponent };